import { KnowledgeRouterLayout } from "@dust-tt/front/components/knowledge/KnowledgeRouterLayout";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";

const KnowledgeOverviewPage = withSuspense(
  () =>
    import("@dust-tt/front/components/pages/knowledge/KnowledgeOverviewPage"),
  "KnowledgeOverviewPage"
);
const KnowledgeGraphPage = withSuspense(
  () => import("@dust-tt/front/components/pages/knowledge/KnowledgeGraphPage"),
  "KnowledgeGraphPage"
);
const KnowledgeFactsPage = withSuspense(
  () => import("@dust-tt/front/components/pages/knowledge/KnowledgeFactsPage"),
  "KnowledgeFactsPage"
);
const KnowledgeVerifyPage = withSuspense(
  () => import("@dust-tt/front/components/pages/knowledge/KnowledgeVerifyPage"),
  "KnowledgeVerifyPage"
);
const KnowledgeCoveragePage = withSuspense(
  () =>
    import("@dust-tt/front/components/pages/knowledge/KnowledgeCoveragePage"),
  "KnowledgeCoveragePage"
);

// /w/:wId/knowledge — the company-knowledge management hub. A parent layout
// renders the left sub-nav (Overview/Graph/Facts/Verify/Coverage) + <Outlet/>;
// each child is a section page. Overview is the index.
export const knowledgeRoutes: RouteObject[] = [
  {
    path: "knowledge",
    element: <KnowledgeRouterLayout />,
    children: [
      { index: true, element: <KnowledgeOverviewPage /> },
      { path: "graph", element: <KnowledgeGraphPage /> },
      { path: "facts", element: <KnowledgeFactsPage /> },
      { path: "verify", element: <KnowledgeVerifyPage /> },
      { path: "coverage", element: <KnowledgeCoveragePage /> },
    ],
  },
];
